import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { Reveal } from './Reveal';

// Editorial closing block — Peri-style. Text "Say hi at [email]" instead of a big button.
export const CTABand = ({ title, body, email, testid = 'cta-band' }) => {
  const { t } = useLanguage();
  const finalEmail = email || t.contactInfo.email;
  const finalBody = body || t.home.closingBody;
  const finalTitle = title || t.home.closingTitle;

  return (
    <section
      className="px-6 lg:px-12 py-28"
      data-testid={testid}
      style={{ borderTop: '1px solid var(--rule)' }}
    >
      <div className="max-w-[1400px] mx-auto text-center">
        <Reveal>
          <p className="overline mb-8">—</p>
          <h2
            className="font-serif font-light text-5xl md:text-7xl leading-[1.02] tracking-tight"
            style={{ color: 'var(--ink)' }}
          >
            {finalTitle}
          </h2>
          <p className="mt-8 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto" style={{ color: 'var(--ink-2)' }}>
            {finalBody}{' '}
            <a
              href={`mailto:${finalEmail}`}
              className="link-underline text-lg md:text-xl"
              data-testid={`${testid}-email`}
              style={{ color: 'var(--ink)' }}
            >
              {finalEmail}
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
};
